// @ts-nocheck
document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".scrolling-promotion");

  sliders.forEach((slider) => {
    if (slider.dataset.initialized) return;
    slider.dataset.initialized = "true";

    const autoScroll = slider.dataset.autoScroll === "true";

    if (!autoScroll) {
      // Initialize Swiper
      new Swiper(slider, {
        slidesPerView: "auto",
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
      });
    } else {
      //auto scrolling
      const promotion = slider.querySelector(".promotion");
      if (!promotion) return;

      const speed = parseFloat(slider.dataset.speed) || 1.6;
      const direction = slider.classList.contains("scrolling-promotion--right") ? "right" : "left";
      const moveSpace = 100;

      promotion.classList.add("promotion--animated");

      for (let i = 0; i < 10; i++) {
        const clone = promotion.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        slider.appendChild(clone);
        const imgWrap = clone.querySelector(".media-wrapper");
        if (imgWrap) imgWrap.classList.remove("loading");
      }

      const duration = (promotion.clientWidth / moveSpace) * speed;
      slider.style.setProperty("--duration", `${duration}s`);

      slider.classList.add(direction === "right" ? "scrolling-promotion--right" : "scrolling-promotion--left");

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          slider.classList.toggle("scrolling-promotion--paused", !entry.isIntersecting);
        });
      }, { rootMargin: "0px 0px 50px 0px" });

      observer.observe(slider);
    }
  });
});